import { NgModule }           from '@angular/core';
import { SharedModule }       from '../../shared/shared.module';
import { HttpClientModule }     from '@angular/common/http';

import { PermissionDetailComponent } from './permission-detail.component'
import { PermissionsComponent } from './permissions.component'
// import { PermissionsRoutingModule } from './permissions-routing.module'
import { PermissionsService, Permission, RoleType, Role, RoleTypePermission, RolePermission, PermissionFields }       from './permissions.service';
import { PracticeSearchService }       from './practice-search.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Globals } from './../../globals';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
  imports: [ReactiveFormsModule, FormsModule, SharedModule, MatTooltipModule],
    declarations: [ PermissionsComponent, PermissionDetailComponent],
    providers:    [ PermissionsService, PracticeSearchService, Globals ]
})
export class PermissionsModule { }


/*
 Copyright 2016 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://angular.io/license
 */
